const getImageSize = (currentImageAsDomElement, sizeAttribute) => {
  try {
    const imgEl = currentImageAsDomElement;
    // @ts-expect-error Element implicitly has an 'any' type because expression of type 'any' can't be used to index type 'HTMLImageElement'
    return imgEl[sizeAttribute];
  } catch (error) {
    return null;
  }
};
export default getImageSize;